import { render, staticRenderFns } from "./HomeSettingsExtra.vue?vue&type=template&id=051228bf&scoped=true"
import script from "./HomeSettingsExtra.vue?vue&type=script&lang=js"
export * from "./HomeSettingsExtra.vue?vue&type=script&lang=js"
import style0 from "./HomeSettingsExtra.vue?vue&type=style&index=0&id=051228bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051228bf",
  null
  
)

export default component.exports